// extracted by mini-css-extract-plugin
export default {"billMessage":"SelectPayment_billMessage__3niKN"};